import React from "react";
import styled from "styled-components";
//import summitImg from "../assets/images/summit.webp";
import WhyThisSummitMatters from "./WhyThisSummitMatters";

const Section = styled.section`
  padding:  20px;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
  padding:  6px;
}
`;

const Card = styled.div`
  max-width: 1200px;
  border-radius: 16px;
`;

const Title = styled.h2`
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #791e1b;
  text-align: center;

   @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #555;
  text-align: center;
  @media (max-width: 768px) {
font-size: 12px;
}
`;

const WhySummit = () => {
  return (
    <>
    <Section>
      <Card>
        {/* <Image src={summitImg} alt="Summit" /> */}

        <Title>Why This Summit Matters</Title>

        <Paragraph>
          At IIT Madras, cutting-edge research is not an end in itself. It is a
          means to solve complex societal and industrial challenges. We believe
          technology and research need to serve as a platform to co-create,
          collaborate, and commit to long-term partnerships.
        </Paragraph>
      </Card>
      
    </Section>
    <WhyThisSummitMatters/>
    </>
  );
};

export default WhySummit;
